<ng-container *ngIf="componentData$ | async as data">
  <div class="banner-container" *ngIf="hasUrl(data)">
    <cx-generic-link [url]="data.urlLink" [target]="getTarget(data)">
      <ng-container *ngTemplateOutlet="highlightcontent; context: { data: data }"> </ng-container>
    </cx-generic-link>
  </div>
  <div class="banner-container" *ngIf="!hasUrl(data)">
    <ng-container *ngTemplateOutlet="highlightcontent; context: { data: data }"> </ng-container>
  </div>
</ng-container>

<ng-template #highlightcontent let-data="data">
  <eb-responsive-media [container]="data.media" [alt]="data.altText"></eb-responsive-media>
  <div class="banner-inner-container">
    <div class="banner-paragraph-container" *ngIf="data.headlineText">
      <h2 class="banner-paragraph-content" [innerHTML]="data.headlineText | safeHtml"></h2>
    </div>
  </div>
  <a
    class="eb-highlight__button"
    *ngIf="data.buttonText && routerLink$ | async as routerLink"
    [href]="routerLink"
    [target]="getTarget(data)"
    >{{ data.buttonText }}</a
  >
</ng-template>
